const styles = {
  container: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: 16,
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 8,
  },
  editButton: {
    height: 28,
    lineHeight: '28px',
    marginTop: '14px',
  },
  editButtonLabel: {
    fontSize: 12,
    paddingLeft: 6,
  },
  inputCon: {
    marginLeft: 8,
    marginRight: 8,
    cursor: 'default',
  },
  input: {
    color: 'rgba(0, 0, 0, 0.870588)',
  },
  inputDisabled: {
    borderBottomStyle: 'none',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/pay/styles/BankAccount.js